import { useEffect, useState } from 'react'

import clientAxios from '../config/axios'

export const useProduct = () => {
  const [productsBackend, setProductsBackend] = useState([])
  const [loadingProducts, setLoading] = useState(true)

  useEffect(() => {
    const consultApi = async () => {
      await clientAxios
        .get('/product/all')
        .then((response) => {
          setProductsBackend(response.data)
          setLoading(false)
        })

        .catch((error) => {
          console.log(error)
        })
    }

    setLoading(true)
    consultApi()
  }, [])

  return { productsBackend, loadingProducts }
}

export default useProduct
